module.exports = __webpack_public_path__ + "img/has-coupon-icon.5d33c140.png";